"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.onMouseEnterHandlerDecorator = exports.TooltipText = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const measureText_1 = require("../../helpers/measureText");
const Text_1 = require("../../Text");
exports.TooltipText = (0, styled_components_1.default)(Text_1.Text) `
    word-break: break-word;
    overflow: hidden;
`;
const onMouseEnterHandlerDecorator = (tooltipHandler, ref) => {
    return () => {
        const { originalWidth, fullWidth } = (0, measureText_1.measureText)(ref);
        if (fullWidth > originalWidth) {
            tooltipHandler();
        }
    };
};
exports.onMouseEnterHandlerDecorator = onMouseEnterHandlerDecorator;
//# sourceMappingURL=helpers.js.map